import React from 'react';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
} from 'mdb-react-ui-kit';
import { OtherFeesSummary } from '../components/otherFeesSummary';
import { OtherFeesTable } from '../components/otherFeesTable';

function OtherFeesPage() {
    return (
      <>
        <div className='d-flex justify-content-center my-5' >
          <MDBCard style={{width: '80%'}}>
            <MDBCardBody>
              <MDBCardTitle className='mb-4'>Podsumowanie</MDBCardTitle>
              <OtherFeesSummary />
              <hr className="hr"/>
              <MDBCardTitle className='mb-4'>Lista pozostałych kosztów</MDBCardTitle>
              <OtherFeesTable />
            </MDBCardBody>
          </MDBCard>
        </div>
      </>
    );
}

export default OtherFeesPage;
